import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Toggle } from 'components/Common/Toggle';

const name = 'clientOptions';

export const ClientOptionsEdit = () => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const hasBillingEmail = !!formik.values.contacts?.billingEmail;

  const handleToggle = (field, value) => {
    formik.setFieldValue(`${name}.${field}`, value);
  };

  const isFieldDisabled = field => {
    const requiresBillingEmail = ['notifyOnAggregatedbill', 'notifyOnInvoice'];
    return requiresBillingEmail.includes(field) && !hasBillingEmail;
  };

  const getWarning = field => {
    if (isFieldDisabled(field)) {
      return t('client.billingEmailRequired');
    }
    return '';
  };

  const getOptionColor = value => (value ? 'info' : 'warning');

  const renderToggle = (field, labelKey, tooltipKey) => {
    const value = formik.values.clientOptions?.[field] ?? false;
    const disabled = isFieldDisabled(field);
    const warning = getWarning(field);

    return (
      <Row
        className={`alert alert-${getOptionColor(
          value,
        )} p-3 mb-2 align-items-center`}
      >
        <Col xs={12}>
          <div className="d-flex align-items-center mt-2">
            <Toggle
              checked={value}
              onChange={() => handleToggle(field, !value)}
              label={t(labelKey)}
              warning={warning}
              disabled={disabled}
            />
            {tooltipKey && (
              <>
                <span
                  id={`${field}Tooltip`}
                  className="ms-1 text-muted"
                  style={{ cursor: 'help', fontSize: '12px' }}
                >
                  ⓘ
                </span>
                <UncontrolledTooltip
                  placement="top"
                  target={`${field}Tooltip`}
                  fade={false}
                >
                  {t(tooltipKey)}
                </UncontrolledTooltip>
              </>
            )}
          </div>
        </Col>
      </Row>
    );
  };

  return (
    <>
      {renderToggle(
        'notifyOnAggregatedbill',
        'client.notifyOnAggregatedBill',
        'client.notifyOnAggregatedBillToolTip',
      )}
      {renderToggle(
        'notifyOnInvoice',
        'client.notifyOnInvoice',
        'client.notifyOnInvoiceToolTip',
      )}
      {renderToggle('notify_organization', 'client.notifyOrganization')}
      {renderToggle('notify_all_managers', 'client.notifyManagers')}
      {renderToggle(
        'notify_created_by_manager',
        'client.notifyCreatedByManager',
      )}
      {renderToggle('notify_applicant', 'client.notifyApplicant')}
      {renderToggle(
        'managerViewPrice',
        'client.managerViewPrice',
        'client.managerViewPriceTooltip',
      )}
      {renderToggle(
        'employeeViewPrice',
        'client.employeeViewPrice',
        'client.employeeViewPriceTooltip',
      )}
      {renderToggle(
        'employeeCreateOrder',
        'client.employeeCreateOrder',
        'client.employeeCreateOrderTooltip',
      )}
      {renderToggle('paymentAllowInvoice', 'client.paymentAllowInvoice')}
    </>
  );
};
